import React from "react";
import { FaCheck, FaTrash } from "react-icons/fa";
import styles from "./BulkSelectBar.module.css";

export function SelectModeButton({ active, onClick, disabled = false }) {
  return (
    <button
      type="button"
      className="buttonSecondary"
      onClick={onClick}
      aria-pressed={active}
      disabled={disabled}
    >
      {active ? (
        <>
          <FaCheck aria-hidden /> Done
        </>
      ) : (
        "Select"
      )}
    </button>
  );
}

export function SelectCheckbox({
  checked,
  onChange,
  label,
  disabled = false,
  className = "",
  children = null,
}) {
  return (
    <label
      className={`${styles.selectControl} ${className}`.trim()}
      onClick={(event) => event.stopPropagation()}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        aria-label={label}
        disabled={disabled}
      />
      {children}
    </label>
  );
}

const BulkSelectBar = ({
  selectedCount,
  allSelected,
  hasHidden = false,
  busy = false,
  onSelectAll,
  onDelete,
  deleteLabel = "Delete",
  busyLabel = "Removing...",
  noun = "items",
  extra = null,
}) => (
  <div className={styles.bulkBar} role="toolbar" aria-label="Bulk actions">
    <span className={styles.bulkCount}>{selectedCount} selected</span>
    <button
      type="button"
      className="buttonSecondary"
      onClick={onSelectAll}
      disabled={busy}
    >
      {allSelected ? "Clear" : hasHidden ? "Select shown" : "Select all"}
    </button>
    {extra}
    {onDelete && (
      <button
        type="button"
        className={`buttonSecondary ${styles.bulkDelete}`}
        onClick={onDelete}
        disabled={selectedCount === 0 || busy}
        aria-label={
          selectedCount > 0
            ? `${deleteLabel} ${selectedCount} selected ${
                selectedCount === 1 && noun.endsWith("s")
                  ? noun.slice(0, -1)
                  : noun
              }`
            : `${deleteLabel} selected ${noun}`
        }
      >
        <FaTrash aria-hidden />
        {busy
          ? busyLabel
          : selectedCount > 0
            ? `${deleteLabel} (${selectedCount})`
            : deleteLabel}
      </button>
    )}
  </div>
);

export default BulkSelectBar;
